import { Action } from 'redux';
import { produce } from 'immer';

import { INotification } from '../../types/common/INotification';
import {
    PUSH_NOTIFICATION,
    POP_NOTIFICATION,
} from '../../constants/common/actions/notifications.constants';
import { LOGOUT } from '../../constants/actions/auth.constants';
import NotificationService from '../../common/services/NotificationService';

interface INotificationAction extends Action {
    payload: INotification | number;
}

type State = INotification[];

export default function (
    state: State = NotificationService.getNotifications(),
    action: INotificationAction,
) {
    switch (action.type) {
        case PUSH_NOTIFICATION:
            return push(state, action.payload as INotification);
        case POP_NOTIFICATION:
            return pop(state, action.payload as number);
        case LOGOUT:
            return [];
        default:
            return state;
    }
}

function push(state: State, notification: INotification) {
    return produce(state, (draft) => {
        draft.push(notification);
    });
}

function pop(state: State, timestamp: number) {
    return produce(state, (draft) => {
        const index = draft.findIndex((item) => item.timestamp === timestamp);
        if (index >= 0) {
            draft.splice(index, 1);
        }
    });
}
